let timelineItems = [
    {
        title: "Teaching Assistant",
        organization: "Carleton University",
        location: "Ottawa, ON",
        description:
            "Teaching Assistant for the COMP 3005 course, Database Management Systems",
        buttonText: "View Frontend Projects",
        date: "January 2024 - April 2024",
        type: "work",
    },
    {
        title: "Software Developer Intern",
        organization: "D2L",
        location: "Waterloo, ON (Remote)",
        description:
            "Worked as a full-stack developer within Team Nightingale, responsible for Brightspace's Performance Plus products.",
        buttonText: "View Frontend Projects",
        date: "May 2023 - August 2023",
        type: "work",
    },
    {
        title: "Web Developer Intern",
        organization: "Nokia",
        location: "Ottawa, ON",
        description:
            "Working as a front-end developer within Nokia's NSP application team.",
        buttonText: "View Frontend Projects",
        date: "January 2023 - April 2023",
        type: "work",
    },
    {
        title: "Software Developer Intern",
        organization: "Geotab",
        location: "Waterloo, ON (Remote)",
        description:
            "Worked as a Software Developer Intern within Geotab's Partner Integrations team. Developed middleware for a data ingestion pipeline using C# and .NET Core. Contributed to API design and made improvements to platform security and architecture. Designed and implemented performant algorithms for processing third-party vehicle metrics.",
        buttonText: "View Frontend Projects",
        date: "May 2022 - August 2022",
        type: "work",
    },
    {
        title: "QA Automation Developer Intern",
        organization: "Ciena",
        location: "Ottawa, ON",
        description:
            "Worked as a QA Automation Developer Intern within Ciena's web-based Manage Control and Plan (MCP) application team. Developed Postman test automation in JavaScript and monitored nightly regression builds in the TeamCity CI tool. Worked in an Agile scrum environment and held sprint demos with QA and Design teams. Discovered and investigated software defects for MCP's Liquid Spectrum Services application.",
        buttonText: "View Frontend Projects",
        date: "May 2021 - December 2021",
        type: "work",
    },
    {
        title: "Co-Founder",
        organization: "Advantage Academy Tutoring",
        location: "Ottawa, ON",
        description:
            "Building and maintaining the company website as well as hiring and managing a team of tutors, overseeing schedules and forming teaching strategies for Zoom lessons. Developing automation for invoice creation and payroll processes with Google Apps Scripts.",
        buttonText: "View Backend Projects",
        date: "September 2020 - Present",
        type: "work",
    },
    {
        title: "Student Mentor",
        organization: "Science Student Success Center (SSSC), Carleton University",
        location: "Ottawa, ON",
        description:
            "Providing expertise and guidance to Carleton Science students to facilitate a positive and successful university experience. Delivering informative workshops on behalf of the Computer Science team to educate students on industry technologies and opportunities.",
        buttonText: "Company Website",
        date: "May 2020 - Present",
        type: "extracurricular",
    },
    {
        title: "Bachelor of Computer Science",
        organization: "Carleton University",
        location: "Ottawa, ON",
        description:
            "Pursuing an Honours Bachelor of Computer Science Degree with a specialization in Software Engineering. Currently in third year standing and an Active mentor at the Science Student Success Center and Athlete on the Carleton Men's Rugby Team.",
        buttonText: "Course Certificate",
        date: "September 2019 - Present",
        type: "education",
    },
    {
        title: "Athlete",
        organization: "Carleton University Men's Rugby Team",
        location: "Ottawa, ON",
        description:
            "Applied strong communication and rigorous work ethic to play a pivotal role in a 2019 championship victory and successful playoff campaign in the 2021 season. ",
        buttonText: "College Projects",
        date: "August 2020 - Present",
        type: "extracurricular",
    },
    {
        title: "Sales Associate",
        organization: "Brown's, Indipendent Grocer",
        location: "Stittsville, ON",
        description:
            "Operated POS system to efficiently process customer transactions and quickly adapted to a large volume of product codes.",
        buttonText: "College Projects",
        date: "June 2019 - September 2020",
        type: "work",
    },
    {
        title: "High School Diploma",
        organization: "Sacred Heart High School",
        location: "Stittsville, ON",
        description:
            "Graduated from Sacred Heart High School with Ontario Scholar distinction. Achieved Honour Roll status in all four years and competed on the Varsity Alpine Skiing team (MIP Award, 2016) as well as the Boys Rugby team.",
        date: "September 2015 - June 2019",
        type: "education",
    },
    {
        title: "Private Tutor",
        organization: "Self-employed",
        location: "Stittsville, ON",
        description:
            "Independently managed tutoring client base and coordinated sessions for students studying High School Mathematics and Sciences. Adapted lessons on an individual basis and encouraged confidence in problem solving to enable success across multiple disciplines.",
        buttonText: "College Projects",
        date: "February 2019 - June 2019",
        type: "work",
    },
    {
        title: "Sales Associate",
        organization: "Sobeys",
        location: "Stittsville, ON",
        description:
            "Collaborated with a team of front-end staff to assist customers in making transactions and retail inquiries as well as offering assistance to other departments when needed.",
        buttonText: "College Projects",
        date: "July 2018 - February 2019",
        type: "work",
    },
    {
        title: "Usher",
        organization: "Landmark Cinemas Canada",
        location: "Kanata, ON",
        description:
            "Collaborated with floor associates to complete various theater service/maintenance tasks on a varying and dynamic schedule.",
        buttonText: "College Projects",
        date: "September 2017 - April 2018",
        type: "work",
    },
    {
        title: "Dietary Aid Specialist",
        organization: "Revera Inc.",
        location: "Stittsville, ON",
        description:
            "Aided senior patrons by serving meals in an assistive and caring capacity in an effort to improve quality of life.",
        buttonText: "College Projects",
        date: "January 2017 - September 2017",
        type: "work",
    },
]

export default timelineItems;